// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tV8j","colBig":"styles_colBig__1hqSk","colSmall":"styles_colSmall__2UXgZ","shopifyNameWrapper":"styles_shopifyNameWrapper__3-IMy"};